import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../stores/actionsList';
import { bindActionCreators } from 'redux';
import { checkTranslation, translate } from '../utils/useful';
import IntractionActionsList from '../components/IntractionActionsList';
import StagesManager from '../components/StagesManager';
import FixedView from '../components/FixedView';
import HttpServices from '../utils/Http.services';
import Responsive from '../components/Responsive';
import moment from 'jalali-moment';
import NotebookOptions from './NotebookOptions';
import AppletFrame from '../components/header/AppletFrame';
import SelectApplet from '../components/useful/SelectApplet';



export class NotebookList extends Component {
    state = {
        template: [
            { image: '/assets/icons/note/addnoteimg.svg', title: '{{lang}}notebook.Blank', des: '{{lang}}notebook.Blank page' },
            { image: '/assets/icons/note/n1.png', title: '{{lang}}notebook.Resume', des: '{{lang}}notebook.Coral' },
            { image: '/assets/icons/note/n2.png', title: '{{lang}}notebook.Resume', des: '{{lang}}notebook.Serif' },
            { image: '/assets/icons/note/n3.png', title: '{{lang}}notebook.Letter', des: '{{lang}}notebook.Spearmint' },
            { image: '/assets/icons/note/n4.png', title: '{{lang}}notebook.Project proposal', des: '{{lang}}notebook.Tropic' },
            { image: '/assets/icons/note/n5.png', title: '{{lang}}notebook.Brochure', des: '{{lang}}notebook.Geometric' },
            { image: '/assets/icons/note/n6.png', title: '{{lang}}notebook.Report', des: '{{lang}}notebook.Luxe' },
            { image: '/assets/icons/note/n1.png', title: '{{lang}}notebook.Report', des: '{{lang}}notebook.Luxe' },
            { image: '/assets/icons/note/n2.png', title: '{{lang}}notebook.Report', des: '{{lang}}notebook.Luxe' },
            { image: '/assets/icons/note/n3.png', title: '{{lang}}notebook.Report', des: '{{lang}}notebook.Luxe' },
            { image: '/assets/icons/note/n4.png', title: '{{lang}}notebook.Report', des: '{{lang}}notebook.Luxe' },
            { image: '/assets/icons/note/n5.png', title: '{{lang}}notebook.Report', des: '{{lang}}notebook.Luxe' },
            { image: '/assets/icons/note/n6.png', title: '{{lang}}notebook.Report', des: '{{lang}}notebook.Luxe' },

        ]

    }

    componentDidMount() {
        if (this.props.setHeader) {
            this.props.setHeader({
                showToolbar: true, showSettings: false, showSettings: false, isPortal: true, title: '{{lang}}Notebook', type: 'notebook'
                // 'toolbar': this.toolbarView,
                // 'showToolbar': true,
                // 'title': this.props.page?.title,
                // 'subtitle': this.props.page?.subtitle,
            })
        }
        this.props.resetId()
        this.init()
    }

    init = () => {
        HttpServices.request('getNotes', {}, (fetchResolve, fetchError) => {
            if (fetchError) {
                console.log(fetchError);
            }
            console.log('fetchresolve', fetchResolve);
            this.setState({ notes: fetchResolve?.info })
        })
    }

    changeView = () => {
        this.setState({ viewMode: !this.state.viewMode })
    }

    render() {
        return (
            <div className='w-100 d-flex window-content-radius h-100 scroll-no-scrollbar' style={{ backgroundColor: '#fff' }}>
                <div className='w-100'>
                    {/* <div className='' style={{ position: 'sticky', top: 0, zIndex: 99 }}>
                        <div className='w-100 ' style={{ zIndex: 10, background: 'linear-gradient(to right, #FFA01C, #F0C000)' }}>
                            <div className='flexcb w-100'>
                                <div className='w-100' style={{}}>
                                    <div className='flexcb w-100 p-2'>
                                        <div className='flexc'>
                                            <p className="white font-size-22 weight-500 mrd-4">{translate('notebook.Notebook')}</p>
                                            <SelectApplet type='Notebook' ref={el => this.selectApplet = el} setData={this.props.setData} />

                                            <AppletFrame language={this.props.language} width={this.props.width} sections={this.props.sections} modules={this.props.modules} changePage={this.props.changePage} />
                                        </div>
                                        <div className='flexc ' >
                                            <button className='mx-2'>
                                                <img className='flexcc' width={24} src="/assets/icons/search-white.svg" alt="" />
                                            </button>
                                            <button className='flexc position-relative mx-2' style={{ cursor: 'pointer' }} ref={el => this.notification = el} onClick={() => { this.notificationView.showView() }} >
                                                <img width={24} src='/assets/icons/notification-white.svg' />
                                                <div className="position-absolute px-1 flexcc" style={{ zIndex: 1, background: '#D70015', color: '#fff', borderRadius: 20, top: -5, left: 15, height: 16, minWidth: 16 }}>
                                                    <p className="text-smaller">2</p>
                                                </div>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> */}
                    <div style={{ backgroundColor: '#F7F4EF' }}>
                        <div className='px-4 py-3 flexcb w-100' >
                            <div>
                                <p className='font-size-14 weight-500 main-c4' style={{ cursor: 'default' }}>{translate('notebook.Start a new document')}</p>
                            </div>
                            <div className='flexc '>
                                <button className='flexcb w-100 dark-blur-hover px-2 py-1 br-5 mx-4'>
                                    <p className='main-c6 pld-2'>{translate('notebook.Yonnect Template')}</p>
                                    <img className='flexcc mld-4' width={24} src='/assets/icons/arrow-ud-gray.svg' />
                                </button>
                                <button className='dark-blur-hover p-1 br-5'>
                                    <img className='flexcc' width={24} src='/assets/icons/more-gray.svg' />
                                </button>
                            </div>
                        </div>
                        <div className='w-100 flexcb px-3 py-3 sc-note-b' style={{ overflowX: 'auto' }}>
                            {this.state.template.map((prop, index) => {
                                return (
                                    <button className='text-left px-2' onClick={() => this.props.changeStage('editor')}>
                                        <img className='note-hover br-5' width={100} src={prop.image} />
                                        <p className='font-size-12 weight-500 main-c4'>{checkTranslation(prop.title)}</p>
                                        <p className='font-size-10 weight-300 main-c7'>{checkTranslation(prop.des)}</p>
                                    </button>
                                )
                            })}
                        </div>
                    </div>
                    <div className='px-4 py-3 flexcb w-100 bg-white'>
                        <div>
                            <p className='font-size-16 weight-500 main-c4'>{translate('notebook.Recent documents')}</p>
                        </div>
                        <div className='flexc '>
                            <button className='flexcb w-100 hover-gray px-2 py-1 br-5 mx-4'>
                                <p className='main-c6'>{translate('notebook.Owned by every one')}</p>
                                <img className='flexcc mld-4' width={24} src='/assets/icons/arrow-bottom-gray.svg' />
                            </button>
                            <button className='mx-3 hover-gray p-1 br-5' onClick={() => this.changeView()}>
                                <img className='flexcc' width={24} src={!this.state.viewMode ? '/assets/icons/note/listview.svg' : '/assets/icons/note/tableview.svg'} />
                            </button>
                            <button className='hover-gray p-1 br-5'>
                                <img className='flexcc' width={24} src='/assets/icons/note/filter.svg' />
                            </button>
                        </div>
                    </div>
                    <div>
                        {!this.state.viewMode ? (
                            <div className='p-2'>
                                <div className='d-flex flex-wrap m-0 w-100'>
                                    {this.props.notes ? this.props.notes.map((item, index) => {
                                        return (
                                            <Responsive className={' d-flex'} key={index} width={this.props.width} media={{ xs: "12", sm: '4', md: '3', lg: "3", xl: "2" }}>
                                                <div className='w-100 m-2 br-10' key={index}>
                                                    <button onClick={() => this.props.changeNotePage(['notebook', item._id])} className='w-100 h-100 hover-gray-sh br-10' style={{ overflow: 'hidden' }}>
                                                        <div className=''>
                                                            <img className='w-100' src='/assets/icons/noteimg.svg' />
                                                            <div className='text-left p-2 w-100'>
                                                                {item.title ? (

                                                                    <p className='font-size-14 weight-400 main-c4' style={{ width: '140px', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{checkTranslation(item?.title)}</p>
                                                                ) : (

                                                                    <p className='font-size-14 weight-400 main-c4'>{translate('notebook.Document')} {this.props.notes.length - index}</p>
                                                                )}
                                                                <div className='flexcb w-100 mt-2'>
                                                                    <p className='font-size-10 weight-300 main-c7' style={{ direction: 'ltr' }}>{moment(item.uDate).format("DD, MMM, YYYY HH:mm")}</p>
                                                                    <NotebookOptions language={this.props.language} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </button>
                                                </div>
                                            </Responsive>
                                        )
                                    }) : (
                                        <div></div>
                                    )}
                                </div>
                            </div>

                        ) : (

                            <div className='p-2'>
                                <div className='d-flex flex-wrap m-0 w-100'>
                                    {this.props.notes ? this.props.notes.map((item, index) => {
                                        return (
                                            <Responsive className={' d-flex'} key={index} width={this.props.width} media={{ xs: "12", sm: '12', md: '6', lg: "6", xl: "6" }}>
                                                <div className='w-100 m-2 br-10' key={index} style={{ border: '1px solid #eee' }}>
                                                    <button onClick={() => this.props.changeNotePage(['notebook', item._id])} className='w-100 h-100 hover-gray-sh br-10' style={{ overflow: 'hidden' }}>
                                                        <div className='flexc'>
                                                            <img width={30} className='mld-2' src='/assets/icons/note/noteimg.svg' />
                                                            <div className='text-left w-100 p-3'>
                                                                {item.title ? (

                                                                    <p className='font-size-14 weight-400 main-c4' style={{ width: '27  0px', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{checkTranslation(item?.title)}</p>
                                                                ) : (

                                                                    <p className='font-size-14 weight-400 main-c4'>{translate('notebook.Document')} {this.props.notes.length - index}</p>
                                                                )}
                                                                <div className='flexcb w-100 mt-2'>
                                                                    <p className='font-size-10 weight-300 main-c7'>{moment(item.uDate).format("DD,  MMM, YYYY HH:mm")}</p>
                                                                    <NotebookOptions />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </button>
                                                </div>
                                            </Responsive>
                                        )
                                    }) : (
                                        <div></div>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NotebookList);